import {
  DELIVERY_ADDRESS_LOAD,
  DELIVERY_ADDRESS_LOAD_SUCCESS,
  DELIVERY_ADDRESS_LOAD_FAIL,
  STATE_LIST,
  STATE_LIST_SUCCESS,
  STATE_LIST_FAIL,
  ADD_NEW_ADDRESS_LOAD,
  ADD_NEW_ADDRESS_LOAD_SUCCESS,
  ADD_NEW_ADDRESS_LOAD_FAIL,
  ADDRESS_SEARCH_LOAD,
  ADDRESS_SEARCH_LOAD_SUCCESS,
  ADDRESS_SEARCH_LOAD_FAIL,
  RESET_ADDRESS_OF_POSTALCODE,
  // POSTAL_ADDRESS_SEARCH_LOAD,
  // POSTAL_ADDRESS_SEARCH_LOAD_SUCCESS,  reused ADDRESS_SEARCH_LOAD_SUCCESS action as data is coming from the same service
  // POSTAL_ADDRESS_SEARCH_LOAD_FAIL,
  FLUSH_ADDRESS_SEARCH,
  GIFT_REGISTRY_ADDRESS_LOAD,
  GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS,
  GIFT_REGISTRY_ADDRESS_LOAD_FAIL,
  EVENT_MANAGEMENT_ADDRESSES_UPDATE,
  EVENT_MANAGEMENT_ADDRESSES_RESET
} from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
  stateData: {},
  addrSearchData: {},
  eventManagementAddresses: [],
//   addrSearchData: {
//     addrSearchResponse: {
//       municipality: [],
//       neighbourhood: [],
//       state: [],
//     },
//   },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case DELIVERY_ADDRESS_LOAD:
      return {
        ...state,
        data: [],
      };
    case DELIVERY_ADDRESS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case DELIVERY_ADDRESS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        // data: null,
        error: action.error,
      };
    case STATE_LIST:
      return {
        ...state,
        loading: true,
      };
    case STATE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        stateData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case STATE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case ADD_NEW_ADDRESS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_ADDRESS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        extraData: 'This is extra info..........',
      };
    case ADD_NEW_ADDRESS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case RESET_ADDRESS_OF_POSTALCODE:
      return {
        ...state,
        // addrSearchData: {
        //   ...state.addrSearchData,
        //   addrSearchResponse: {
        //     ...state.addrSearchData.addrSearchResponse,
        //     municipality: [],
        //     neighbourhood: [],
        //     state: [],
        //   },
        // },
        addrSearchData: null,
      };
    // case POSTAL_ADDRESS_SEARCH_LOAD:
    //   return {
    //     ...state,
    //     loading: false,
    //     loaded: true,
    //     // addrSearchData: {
    //     //   ...state.addrSearchData,
    //     //   addrSearchResponse: {
    //     //     ...state.addrSearchData.addrSearchResponse,
    //     //     municipality: [],
    //     //     neighbourhood: [],
    //     //     state: [],
    //     //   },
    //     // },
    //     addrSearchData: action.result,
    //     error: null,
    //     extraData: 'This is extra info..........',
    //   };
    // case POSTAL_ADDRESS_SEARCH_LOAD_FAIL:
    //   return {
    //     ...state,
    //     loading: false,
    //     loaded: true,
    //     addrSearchData: null,
    //     // addrSearchData: {
    //     //   ...state.addrSearchData,
    //     //   addrSearchResponse: {
    //     //     ...state.addrSearchData.addrSearchResponse,
    //     //     municipality: [],
    //     //     neighbourhood: [],
    //     //     state: [],
    //     //   },
    //     // },
    //     error: null,
    //     extraData: 'This is extra info..........',
    //   };
    case ADDRESS_SEARCH_LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADDRESS_SEARCH_LOAD_SUCCESS: {
      // const data = action.result;
      // if (data.status && data.status.status === 'success') {
      return {
        ...state,
        loading: false,
        loaded: true,
        // addrSearchData: {
        //   ...state.addrSearchData,
        //   addrSearchResponse: {
        //     ...state.addrSearchData.addrSearchResponse,
        //     municipality: (data.addrSearchResponse && data.addrSearchResponse.municipality) ? data.addrSearchResponse.municipality : [...state.addrSearchData.addrSearchResponse.municipality],
        //     neighbourhood: (data.addrSearchResponse && data.addrSearchResponse.neighbourhood) ? data.addrSearchResponse.neighbourhood : [...state.addrSearchData.addrSearchResponse.neighbourhood],
        //     state: (data.addrSearchResponse && data.addrSearchResponse.state) ? data.addrSearchResponse.state : [...state.addrSearchData.addrSearchResponse.state],
        //   },
        // },
        addrSearchData: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
      // }
      // return {
      //   ...state,
      //   loading: false,
      //   loaded: true,
      //   addrSearchData: {
      //     ...state.addrSearchData,
      //     addrSearchResponse: {
      //       ...state.addrSearchData.addrSearchResponse,
      //       municipality: (data.addrSearchResponse && data.addrSearchResponse.municipality) ? data.addrSearchResponse.municipality : [],
      //       neighbourhood: (data.addrSearchResponse && data.addrSearchResponse.neighbourhood) ? data.addrSearchResponse.neighbourhood : [],
      //       state: (data.addrSearchResponse && data.addrSearchResponse.state) ? data.addrSearchResponse.state : [],
      //     },
      //   },
      //   error: null,
      //   extraData: 'This is extra info..........',
      // };
    }
    case ADDRESS_SEARCH_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        // addrSearchData: {
        //   ...state.addrSearchData,
        //   addrSearchResponse: {
        //     ...state.addrSearchData.addrSearchResponse,
        //     municipality: [],
        //     neighbourhood: [],
        //     state: [],
        //   },
        // },
        addrSearchData: null,
        error: action.error,
      };
    case FLUSH_ADDRESS_SEARCH: {
      return Object.assign({}, state, action.data);
    };
    case GIFT_REGISTRY_ADDRESS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        giftRegistryAddress: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GIFT_REGISTRY_ADDRESS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case EVENT_MANAGEMENT_ADDRESSES_UPDATE:
      return {
        ...state,
        eventManagementAddresses: action.payload,
      };
    case EVENT_MANAGEMENT_ADDRESSES_RESET:
      return {
        ...state,
        eventManagementAddresses: [],
      };
    default:
      return state;
  }
}
